/** @format */
import jQuery from 'jquery';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import '@js/vendor/priority-plus.js';
import '@js/vendor/ls.respimg.min.js';
import '@js/vendor/lazysizes.min.js';
import '@js/vendor/jquery-accessible-tabs.js';
import '@js/vendor/a11y-dialog.min.js';
import { KEY_TAB, HTML_ELEMENT } from './globals.js';
import '@js/event-listeners.js';
import '@js/header.js';
import '@js/date-filters.js';
import '@js/event-card.js';
import '@js/sliders.js';
import '@js/masthead-video.js';
import '@js/aria-modal.js';
import '@js/aria-disclosure.js';
import '@js/priority-booking-button.js';
import '@js/npl-poem-filters.js';
import '@js/articles-and-stories-filters.js'
import '@js/zendesk-mod.js'
import '@js/account-login.js'
import '@js/mailing-signup.js'
import '@js/shopify-buy-button.js'
import '@js/tnew-donations.js'
import '@js/accessible-tabs.js'
import '@js/promo-code.js'


jQuery(function($) {

    const EVENT_DATE_FILTERS = $(".c-whats-on-header__natural-language-filters .c-pill");
    const EVENT_DATE_SUBMIT = $(".c-whats-on-header__date-range-submit");
    const EVENT_TYPE_FILTERS = $(".c-whats-on-header__artforms .c-pill");
    const EVENT_VIEW_TOGGLE = $(".c-event-listing-header__view-toggle .c-pill");
    const EVENT_SEARCH_FORM = $(".c-whats-on-header__search");
    const EVENT_ACCESS_LINK = $(".c-whats-on-header__access-link");
    const EVENT_CLEAR_FILTER = $(".c-event-listing-header__clear .c-pill");

    // What's on Filter states

    $(EVENT_DATE_FILTERS).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_DATE_SUBMIT).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_TYPE_FILTERS).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_VIEW_TOGGLE).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_ACCESS_LINK).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_CLEAR_FILTER).on( "click", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });
    $(EVENT_SEARCH_FORM).on( "submit", function() {
        $(HTML_ELEMENT).addClass("state--is-filtering");
    });


    // Priority plus navigation on jump navigation
    // https://github.com/jayfreestone/priority-plus

    if ($('.js-jump-nav').length) {

        priorityPlus(document.querySelector('.js-jump-nav'), {
            innerToggleTemplate: ({ toggleCount, totalCount }) => `${toggleCount && toggleCount == totalCount ? '<i class="far fa-plus" aria-hidden="true"></i> Jump to section' : '<i class="far fa-ellipsis" aria-hidden="true"></i> More'}`,
            collapseAtCount: 2,
        });

        // Add a class to the jump nav on stick so we can adjust styling

        const el = document.querySelector(".c-jump-nav");
        const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1),
            {  rootMargin: '-1px', threshold: [1] }
        );
        observer.observe(el);

    }

    // Priority plus navigation on section navigation (NPL and Hayward)

    if ($('.js-section-nav').length) {

        priorityPlus(document.querySelector('.js-section-nav'), {
            innerToggleTemplate: ({ toggleCount, totalCount }) => `${toggleCount && toggleCount == totalCount ? '<i class="far fa-plus" aria-hidden="true"></i> Navigate this section' : '<i class="far fa-ellipsis" aria-hidden="true"></i> More'}`,
            collapseAtCount: 4,
        });

        // Sedtion navigation Submenus

        $('.js-section-nav .sub-menu').addClass('is-hidden');

        $('.js-section-nav .menu-item-description').each(function() {
            $parent = $(this).parent().parent();
            $(this).appendTo($parent);
        });

        $('.js-section-nav .menu-item-has-children > a').each(function(){
            $(this).after('<button class="c-main-menu__submenu-toggle" aria-expanded="false"><i aria-hidden="true" class="fal fa-angle-down"></i><span class="u-hidden-visually">Open sub menu for ' + $(this).text() + '</span></button>');
        });

        $('.js-section-nav .menu-item-has-children').on('click', 'button', function() {
            $(this).next().toggleClass('is-hidden');
            $(this).toggleAttrVal('aria-expanded', 'true', 'false');
        });

    }


    /*
     * Lightbox / gallery
     * Used for construkt embeds
     * and image galleries
     */
    const lightboxElements = $('.js-lightbox-video');
    const lightgalleryElements = $('.js-lightgallery');

    // Embedded media / videos
    Array.from(lightboxElements).forEach((lightbox, index) => {

        lightbox.id = 'video-' + index;

        lightGallery(lightbox, {
            plugins: [lgVideo],
            download: false,
            counter: false,
            width: '90%',
            trapFocus: true,
            closable: true,
            closeOnTap: true,
            enableSwipe: false,
            resetScrollPosition: true,
            youTubePlayerParams: {
                modestbranding : 1
            },
            getCaptionFromTitleOrAlt: false,
            licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
                download: false,
            },
        });

        handleLightboxEvents(lightbox, true);
    });

    // Image galleries
    Array.from(lightgalleryElements).forEach((lightgallery, index) => {

        lightgallery.id = 'gallery-' + index;

        lightGallery(lightgallery, {
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: 'data-thumbnail-image',
            selector: '.js-light-gallery-item',
            download: false,
            counter: false,
            width: '90%',
            licenseKey: '7193FD74-868442F8-AFC59789-16D26BC0',
            mobileSettings: {
                controls: true,
                showCloseIcon: true,
                download: false,
            }
        });

        handleLightboxEvents(lightgallery);
    });

    let lastFocused = null

    /*
    * Adds custom events when opening and closing lightgalleries
    * @param lightbox - Lightbox wrapper element used to initialise the plugin
    */
    function handleLightboxEvents(lightbox, isVideo) {
        // Save the focus position before opening the lightbox
        lightbox.addEventListener('lgBeforeOpen', () => {
            lastFocused = document.activeElement;

            if(isVideo) {
                window.addEventListener("keydown", handleLightboxKeydown);
            }

        });

        // Go back to the last point of focus when closing the lightbox
        lightbox.addEventListener('lgBeforeClose', () => {
            if(lastFocused) {
                lastFocused.focus();
                lastFocused = null;
            }
        });
        // There's an access issue with the lightbox that we need to fix ourselves
        // Once the close button is focused, there's no way to return the focus to the video
        function handleLightboxKeydown(e) {
            const isTabPressed = (e.key === KEY_TAB);

            if(isTabPressed) {
                if (e.target.classList.contains('lg-close')) {
                    e.preventDefault();
                    let video = e.target.parentElement.parentElement.querySelector('.lg-video-object');
                    if(video) {
                        video.focus();
                    }
                }
            } else {
                return;
            }
        }

    }








})

// Access preferences form
window.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('access-preferences-form')


    if (form) {
        form.addEventListener('submit', (e) => {
            const inputs = form.getElementsByTagName('input')
            // grab the checked values
            const checkedItems = Array.from(inputs)
                .filter((input) => input.checked)
                .map(input => input.value)

            // Close the modal on submission
            if (window.ARIAmodal !== undefined) {
                window.ARIAmodal.closeModal()
            }

            const urlParams = new URLSearchParams(window.location.search)
            // remove any existing accessibility params
            if (urlParams.has('accessibility')) {
                urlParams.delete('accessibility')
            }

            if (checkedItems.length > 0) {
                window.location.href = `${window.location.origin}/${window.location.pathname}/?accessibility=${checkedItems.join(',')}&${urlParams.toString()}`
            } else {
                let url = `${window.location.origin}/${window.location.pathname}`;
                if (Array.from(urlParams.entries()).length > 0) {
                    url += `?${urlParams.toString()}`
                }
                window.location.href = url
            }

            e.preventDefault()
        })
    }

    // Accessible events scroll on Accessible events page
    const accessEventsSection = document.getElementById('access-events')
    if (document.body.classList.contains('page-template-access-page') && accessEventsSection) {
        const urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('accessibility')) {
            accessEventsSection.scrollIntoView({ behavior: "smooth", inline: "nearest" })
        }
    }

})



